import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CxTableService } from '../../services/cx-table.service';
import { DialogService } from '../../../dynamicdialog';
import { CxDataGridService } from '../../cx-datagrid.service';
import { cloneDeep } from '../../../cx-adv-filters/utils';

@Component({
    selector: 'cx-edit-view-name-modal',
    templateUrl: 'edit-viewname.component.html',
})
export class EditViewNameModalComponent implements OnChanges {
    @Output() close = new EventEmitter();
    @Output() updated = new EventEmitter();

    @Input() view: any = { id: '', name: '' };
    tempView: any = { id: '', name: '' };

    visible = true;
    constructor (
        public cxDataGridService: CxDataGridService,
        public tableService: CxTableService
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['view']) {
            this.tempView = cloneDeep(changes['view'].currentValue);
        }
    }
    

    update(e: MouseEvent) {
        this.cxDataGridService.updateViewName({ id: this.view.id, name: this.tempView.name }).subscribe((x) => {
            this.updated.emit('updated');
        })
    }

    cancel (e: MouseEvent) {
        this.close.emit('close')
    }

    hide () {
        this.close.emit('close')
    }
}
